import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.results.item');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const WizRoute: any;

@Component({
    selector: 'wiz-page-admin-results-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.results.item/view.scss */
:host {
  display: block;
}

.result-detail-page {
  width: min(100%, 1240px);
  margin: 0 auto;
  padding: 18px 24px 36px;
  color: #172033;
}

.result-back {
  display: inline-flex;
  margin-bottom: 12px;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.result-header,
.result-form-card,
.result-viewer,
.result-empty {
  border: 1px solid #e2e8f0;
  background: #fff;
}

.result-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 20px 22px;
  border-radius: 16px;
}

.result-header__identity {
  display: flex;
  align-items: center;
  gap: 10px;
}

.result-header h1 {
  margin: 0;
  color: #0f172a;
  font-size: 23px;
  font-weight: 780;
}

.result-header__identity span {
  padding: 5px 8px;
  border-radius: 7px;
  background: #f1f5f9;
  color: #475569;
  font-size: 11px;
  font-weight: 750;
}

.result-header p {
  margin: 6px 0 0;
  color: #64748b;
  font-size: 12px;
}

.result-header__summary {
  display: grid;
  min-width: 94px;
  padding: 10px 12px;
  border-radius: 12px;
  background: #eef2ff;
  text-align: center;
}

.result-header__summary strong {
  color: #3730a3;
  font-size: 19px;
}

.result-header__summary span {
  margin-top: 2px;
  color: #6366f1;
  font-size: 10px;
  font-weight: 700;
}

.result-form-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-top: 14px;
}

.result-form-card {
  min-width: 0;
  padding: 16px;
  border-radius: 14px;
  transition: border-color 150ms ease, box-shadow 150ms ease;
}

.result-form-card.is-selected {
  border-color: #818cf8;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

.result-form-card.is-disabled {
  background: #fafafa;
}

.result-form-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.result-form-card__short,
.result-viewer__eyebrow {
  color: #6366f1;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.06em;
}

.result-form-card h2 {
  margin: 4px 0 0;
  color: #0f172a;
  font-size: 14px;
  font-weight: 740;
  line-height: 1.35;
}

.result-form-card__status {
  flex: 0 0 auto;
  padding: 5px 8px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 750;
}

.is-pending {
  background: #f1f5f9;
  color: #64748b;
}

.is-in-progress {
  background: #fff7ed;
  color: #c2410c;
}

.is-admin-pending {
  background: #eef2ff;
  color: #4338ca;
}

.is-submitted {
  background: #ecfdf5;
  color: #047857;
}

.result-form-card__summary {
  min-height: 38px;
  margin: 12px 0 0;
  color: #334155;
  font-size: 12px;
  font-weight: 650;
  line-height: 1.55;
}

.result-form-card__date {
  margin-top: 7px;
  color: #94a3b8;
  font-size: 10px;
}

.result-form-card__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 13px;
}

.result-form-card__actions button,
.result-form-card__actions a,
.result-viewer__downloads button {
  min-height: 32px;
  padding: 0 10px;
  border: 1px solid #cbd5e1;
  border-radius: 7px;
  background: #fff;
  color: #475569;
  font-size: 11px;
  font-weight: 720;
}

.result-form-card__actions button:first-child {
  border-color: #4f46e5;
  background: #4f46e5;
  color: #fff;
}

.result-form-card__actions button:disabled,
.result-viewer__downloads button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.result-empty {
  margin-top: 14px;
  padding: 42px 20px;
  border-radius: 14px;
  text-align: center;
}

.result-empty strong {
  color: #334155;
  font-size: 14px;
}

.result-empty p {
  margin: 7px 0 13px;
  color: #94a3b8;
  font-size: 12px;
}

.result-empty a {
  color: #4f46e5;
  font-size: 12px;
  font-weight: 750;
}

.result-viewer {
  scroll-margin-top: 16px;
  min-height: 180px;
  margin-top: 14px;
  padding: 18px;
  border-radius: 16px;
}

.result-viewer__loading,
.result-state {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  min-height: 120px;
  color: #94a3b8;
  font-size: 12px;
}

.result-viewer__error {
  display: grid;
  justify-items: center;
  min-height: 150px;
  align-content: center;
  padding: 24px;
  border: 1px solid #fecdd3;
  border-radius: 11px;
  background: #fff7f8;
  text-align: center;
}

.result-viewer__error strong {
  color: #9f1239;
  font-size: 13px;
}

.result-viewer__error p {
  margin: 6px 0 13px;
  color: #be123c;
  font-size: 11px;
}

.result-viewer__error button {
  min-height: 34px;
  padding: 0 12px;
  border: 1px solid #fda4af;
  border-radius: 8px;
  background: #fff;
  color: #be123c;
  font-size: 11px;
  font-weight: 720;
}

.result-state--error {
  min-height: 0;
  padding: 13px;
  border: 1px solid #fecdd3;
  border-radius: 10px;
  background: #fff1f2;
  color: #be123c;
}

.result-viewer__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 14px;
  border-bottom: 1px solid #e2e8f0;
}

.result-viewer__head h2 {
  margin: 4px 0 0;
  color: #0f172a;
  font-size: 19px;
  font-weight: 760;
}

.result-viewer__downloads {
  display: flex;
  gap: 6px;
}

.result-score {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-top: 14px;
}

.result-score--mmse {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.result-score > div {
  padding: 11px 12px;
  border: 1px solid #e0e7ff;
  border-radius: 10px;
  background: #f8faff;
}

.result-score span,
.result-score strong {
  display: block;
}

.result-score span {
  color: #64748b;
  font-size: 10px;
  font-weight: 700;
}

.result-score strong {
  margin-top: 4px;
  color: #312e81;
  font-size: 13px;
}

.result-workspace {
  display: grid;
  grid-template-columns: 210px minmax(0, 1fr);
  align-items: start;
  gap: 12px;
  margin-top: 14px;
}

.result-section-nav {
  position: sticky;
  top: 16px;
  padding: 10px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fff;
}

.result-section-nav > strong {
  display: block;
  padding: 3px 5px 9px;
  color: #475569;
  font-size: 11px;
}

.result-section-nav > div {
  display: grid;
  gap: 3px;
  max-height: calc(100vh - 170px);
  overflow-y: auto;
}

.result-section-nav button {
  display: grid;
  grid-template-columns: 22px minmax(0, 1fr) auto;
  align-items: center;
  gap: 7px;
  min-height: 34px;
  padding: 5px 7px;
  border-radius: 7px;
  color: #64748b;
  text-align: left;
}

.result-section-nav button:hover,
.result-section-nav button.is-active {
  background: #eef2ff;
  color: #3730a3;
}

.result-section-nav button span {
  display: grid;
  width: 22px;
  height: 22px;
  place-items: center;
  border-radius: 6px;
  background: #f1f5f9;
  font-size: 10px;
  font-weight: 750;
}

.result-section-nav button b {
  overflow: hidden;
  font-size: 11px;
  font-weight: 650;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.result-section-nav button i {
  color: #94a3b8;
  font-size: 9px;
  font-style: normal;
}

.result-sections {
  display: grid;
  gap: 8px;
  min-width: 0;
}

.result-section {
  scroll-margin-top: 16px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fff;
}

.result-section__head {
  display: flex;
  width: 100%;
  min-height: 47px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 9px 12px;
  text-align: left;
}

.result-section__head:hover {
  background: #f8fafc;
}

.result-section__head > div,
.result-section__head small {
  display: flex;
  align-items: center;
  gap: 8px;
}

.result-section__head > div > span {
  display: grid;
  width: 24px;
  height: 24px;
  place-items: center;
  border-radius: 6px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 10px;
  font-weight: 750;
}

.result-section.is-open .result-section__head > div > span {
  background: #e0e7ff;
  color: #4338ca;
}

.result-section h3 {
  margin: 0;
  color: #1e293b;
  font-size: 14px;
  font-weight: 710;
}

.result-section__head small {
  color: #94a3b8;
  font-size: 10px;
}

.result-section__head small b {
  display: grid;
  width: 23px;
  height: 23px;
  place-items: center;
  border-radius: 6px;
  background: #f1f5f9;
  color: #475569;
  font-size: 15px;
}

.result-section__body {
  padding: 0 13px 12px;
  border-top: 1px solid #f1f5f9;
}

.result-section__body > p {
  margin: 10px 0 0;
  color: #64748b;
  font-size: 11px;
}

.result-answers {
  margin-top: 8px;
}

.result-answers > div + div {
  border-top: 1px solid #f1f5f9;
}

:host ::ng-deep .result-answers .question-shell {
  gap: 10px;
  padding: 12px 0;
  border: 0;
  border-radius: 0;
  background: #fff;
  box-shadow: none;
}

:host ::ng-deep .result-answers .question-shell__number {
  min-width: auto;
  padding: 3px 7px;
  border-radius: 6px;
  background: #f1f5f9;
  color: #475569;
}

:host ::ng-deep .result-answers .question-shell__title {
  color: #1f2937;
  font-size: 13px;
}

:host ::ng-deep .result-answers .choice-card,
:host ::ng-deep .result-answers .binary-choice__card,
:host ::ng-deep .result-answers .likert-band,
:host ::ng-deep .result-answers .clinical-block,
:host ::ng-deep .result-answers .matrix-card,
:host ::ng-deep .result-answers .lab-result-row {
  border-radius: 8px;
  box-shadow: none;
}

.result-download-overlay {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: grid;
  place-items: center;
  padding: 20px;
}

.result-download-overlay__backdrop {
  position: absolute;
  inset: 0;
  background: rgba(241, 245, 249, 0.76);
  backdrop-filter: blur(5px);
}

.result-download-overlay__card {
  position: relative;
  z-index: 1;
  width: min(100%, 300px);
  padding: 24px;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  background: #fff;
  text-align: center;
  box-shadow: 0 22px 48px rgba(15, 23, 42, 0.14);
}

.result-download-overlay__card .result-spinner {
  margin: 0 auto 10px;
}

.result-download-overlay__card strong,
.result-download-overlay__card p {
  display: block;
}

.result-download-overlay__card p {
  margin: 5px 0 0;
  color: #94a3b8;
  font-size: 11px;
}

.result-spinner {
  display: block;
  width: 20px;
  height: 20px;
  border: 2px solid #c7d2fe;
  border-top-color: #4f46e5;
  border-radius: 999px;
  animation: result-spin 0.8s linear infinite;
}

@keyframes result-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 900px) {
  .result-form-grid {
    grid-template-columns: 1fr;
  }
  .result-workspace {
    grid-template-columns: 1fr;
  }
  .result-section-nav {
    position: static;
  }
  .result-section-nav > div {
    display: flex;
    max-height: none;
    overflow-x: auto;
  }
  .result-section-nav button {
    flex: 0 0 180px;
  }
}
@media (max-width: 640px) {
  .result-detail-page {
    padding: 14px 12px 28px;
  }
  .result-header {
    align-items: flex-start;
    padding: 16px;
  }
  .result-header h1 {
    font-size: 20px;
  }
  .result-viewer {
    padding: 13px;
  }
  .result-viewer__head {
    align-items: flex-start;
    flex-direction: column;
  }
  .result-score,
  .result-score--mmse {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
/* Unified admin visual hierarchy */
.result-detail-page {
  padding: 24px 28px 40px;
  color: var(--admin-text, #334155);
}

.result-back {
  color: var(--admin-text-muted, #64748b);
}

.result-back:hover {
  color: var(--admin-primary, #4f46e5);
}

.result-header,
.result-form-card,
.result-viewer,
.result-empty {
  border-color: var(--admin-border, #dce2ea);
  background: var(--admin-surface, #fff);
}

.result-header {
  border-radius: 14px;
  background: radial-gradient(circle at 92% 15%, var(--admin-primary-soft, #eef2ff), rgba(255, 255, 255, 0) 34%), var(--admin-surface, #fff);
  box-shadow: var(--admin-shadow-card, 0 1px 2px rgba(15, 23, 42, 0.04));
}

.result-header h1 {
  color: var(--admin-text-strong, #111827);
}

.result-header__identity span {
  background: var(--admin-surface-subtle, #f8fafc);
  color: var(--admin-text, #334155);
}

.result-header__summary {
  background: var(--admin-primary-soft, #eef2ff);
}

.result-form-card {
  --form-accent: var(--admin-text-muted, #64748b);
  --form-soft: var(--admin-surface-subtle, #f8fafc);
  overflow: hidden;
  border-radius: 12px;
  background: radial-gradient(circle at 100% 0, var(--form-soft), rgba(255, 255, 255, 0) 42%), var(--admin-surface, #fff);
  box-shadow: var(--admin-shadow-card, 0 1px 2px rgba(15, 23, 42, 0.04));
}

.result-form-card[data-form-code=original_survey] {
  --form-accent: var(--admin-primary, #4f46e5);
  --form-soft: var(--admin-primary-soft, #eef2ff);
}

.result-form-card[data-form-code=geriatric_depression] {
  --form-accent: var(--admin-success, #047857);
  --form-soft: var(--admin-success-soft, #ecfdf5);
}

.result-form-card[data-form-code=mmse] {
  --form-accent: var(--admin-warning, #b45309);
  --form-soft: var(--admin-warning-soft, #fffbeb);
}

.result-form-card.is-selected {
  border-color: var(--form-accent);
  box-shadow: 0 0 0 2px var(--form-soft), var(--admin-shadow-card, 0 1px 2px rgba(15, 23, 42, 0.04));
}

.result-form-card__short {
  color: var(--form-accent);
}

.result-form-card h2 {
  color: var(--admin-text-strong, #111827);
}

.result-form-card__actions button:first-child {
  border-color: var(--form-accent);
  background: var(--form-accent);
}

.result-viewer {
  border-radius: 14px;
  box-shadow: var(--admin-shadow-card, 0 1px 2px rgba(15, 23, 42, 0.04));
}

.result-viewer__head {
  padding-bottom: 14px;
  border-bottom: 1px solid var(--admin-border-soft, #edf1f5);
}

.result-viewer__eyebrow {
  color: var(--admin-primary, #4f46e5);
}

.result-section-nav {
  border-color: var(--admin-border, #dce2ea);
  background: var(--admin-surface-subtle, #f8fafc);
}

.result-section.is-open {
  border-color: var(--admin-primary, #4f46e5);
  background: var(--admin-primary-soft, #eef2ff);
}

.result-score > div,
.result-score--mmse > div {
  border-color: var(--admin-border-soft, #edf1f5);
  background: var(--admin-surface-subtle, #f8fafc);
}

@media (max-width: 640px) {
  .result-detail-page {
    padding: 16px 16px 32px;
  }
}`],
})
export class PageAdminResultsItemComponent implements OnInit {
    public id: string = '';
    public loading: boolean = true;
    public errorMessage: string = '';
    public subject: any = {};
    public forms: any[] = [];
    public selectedFormCode: string = '';
    public selectedContext: any = null;
    public formLoading: boolean = false;
    public formErrorMessage: string = '';
    public downloadKey: string = '';
    public expandedSections: { [key: number]: boolean } = {};
    private formContexts: { [key: string]: any } = {};

    constructor(@Inject( Service) public service: Service) { }

    private payload(data: any): any {
        if (data && data.data !== undefined) return data.data;
        return data || {};
    }

    public async ngOnInit() {
        await this.service.init();
        this.id = WizRoute.segment.id;
        await this.load();
    }

    public async load() {
        this.loading = true;
        this.errorMessage = '';
        await this.service.render();

        const { code, data } = await wiz.call('get', { id: this.id });
        this.loading = false;
        if (code !== 200) {
            this.errorMessage = (
                (data && data.message)
                || '대상자 결과를 불러오지 못했습니다.'
            );
            await this.service.render();
            return;
        }

        const payload = this.payload(data);
        this.subject = payload.subject || {};
        this.id = this.subject.id || this.id;
        this.forms = payload.forms || [];
        await this.service.render();

        const storedCode = this.storedFormCode();
        const first = this.completedForms().find(
            (form: any) => form.code === storedCode,
        ) || this.completedForms()[0];
        if (first) await this.openForm(first, false);
    }

    private formStorageKey(): string {
        return `reviewops.results.selected-form.${this.id}`;
    }

    private storedFormCode(): string {
        try {
            return sessionStorage.getItem(this.formStorageKey()) || '';
        } catch (e) {
            return '';
        }
    }

    private storeFormCode(code: string) {
        try {
            sessionStorage.setItem(this.formStorageKey(), code);
        } catch (e) {}
    }

    public completedForms(): any[] {
        return (this.forms || []).filter(
            (form: any) => this.canUse(form),
        );
    }

    public canUse(form: any): boolean {
        return (
            form?.overall_status
            || form?.status
        ) === 'submitted' && !!form?.schema_ready;
    }

    public formTitle(form: any): string {
        if (form?.code === 'original_survey') {
            return '한의 검진 설문(CRF)';
        }
        return form?.title || '검사·설문';
    }

    public formShortTitle(form: any): string {
        const labels: any = {
            original_survey: 'CRF',
            geriatric_depression: 'SGDS-K',
            mmse: 'MMSE-K',
        };
        return labels[form?.code] || this.formTitle(form);
    }

    public formStatus(form: any): string {
        return (
            form?.overall_status
            || form?.status
            || 'pending'
        );
    }

    public formStatusLabel(form: any): string {
        const labels: any = {
            pending: '미작성',
            in_progress: '작성 중',
            admin_pending: '관리자 기록 대기',
            submitted: '완료',
        };
        return labels[this.formStatus(form)] || '미작성';
    }

    public formStatusClass(form: any): string {
        return 'is-' + this.formStatus(form).replace('_', '-');
    }

    public completedAt(form: any): string {
        if (!form) return '-';
        const value = form.code === 'original_survey'
            ? form.admin_submitted_at || form.submitted_at
            : form.submitted_at;
        return this.formatDateTime(value);
    }

    public formActivityLabel(form: any): string {
        if (this.canUse(form)) {
            return `완료 ${this.completedAt(form)}`;
        }
        const updated = this.formatDateTime(form?.updated);
        if (this.formStatus(form) === 'admin_pending') {
            return '대상자 제출 완료 · 관리자 기록 필요';
        }
        if (this.formStatus(form) === 'in_progress') {
            return updated === '-'
                ? '작성 중'
                : `최근 저장 ${updated}`;
        }
        return '아직 시작하지 않음';
    }

    public resultSummary(form: any): string {
        if (!this.canUse(form)) return this.formStatusLabel(form);
        const result = form?.result || {};
        if (form.code === 'geriatric_depression') {
            const label = result.flagged
                ? '상담 권고 기준 해당'
                : '기준 미해당';
            return `${result.total || 0} / ${result.max_score || 15}점 · ${label}`;
        }
        if (form.code === 'mmse') {
            const classification = result?.classification?.label || '판정 대기';
            return `${result.total || 0} / ${result.max_score || 30}점 · ${classification}`;
        }
        return '대상자 설문과 관리자 기록 완료';
    }

    public formatDateTime(value: any): string {
        if (!value) return '-';
        return String(value).slice(0, 16);
    }

    public async openForm(form: any, scroll: boolean = true) {
        if (!this.canUse(form) || this.formLoading) return;
        this.selectedFormCode = form.code;
        this.formErrorMessage = '';
        this.storeFormCode(form.code);

        if (this.formContexts[form.code]) {
            this.selectedContext = this.formContexts[form.code];
            this.resetSections();
            await this.service.render();
            if (scroll) this.scrollToViewer();
            return;
        }

        this.formLoading = true;
        this.selectedContext = null;
        await this.service.render();
        const { code, data } = await wiz.call('form', {
            id: this.id,
            form_code: form.code,
        });
        this.formLoading = false;

        if (code === 200) {
            const context = this.payload(data);
            this.formContexts[form.code] = context;
            this.selectedContext = context;
            this.resetSections();
            await this.service.render();
            if (scroll) this.scrollToViewer();
            return;
        }

        this.formErrorMessage = (
            (data && data.message)
            || '양식 결과를 불러오지 못했습니다.'
        );
        await this.service.render();
    }

    public async retrySelectedForm() {
        const form = this.selectedForm();
        if (!form?.code) return;
        await this.openForm(form, false);
    }

    private resetSections() {
        this.expandedSections = {};
        if (this.visibleSections().length > 0) {
            this.expandedSections[0] = true;
        }
    }

    private scrollToViewer() {
        setTimeout(() => {
            document.getElementById('results-form-viewer')?.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        });
    }

    public schema(): any {
        return this.selectedContext?.template?.schema || {
            sections: [],
            scales: {},
        };
    }

    public answers(): any {
        return this.selectedContext?.answers || {};
    }

    public scales(): any {
        return this.schema()?.scales || {};
    }

    public sectionVisible(section: any): boolean {
        const show = section?.showIf;
        if (!show) return true;
        if (show.subjectField === 'gender' && show.eq) {
            return (this.subject?.gender || 'O') === show.eq;
        }
        return true;
    }

    public questionVisible(question: any): boolean {
        const condition = question?.showIf;
        if (!condition) return true;
        const value = condition.key
            ? this.answers()[condition.key]
            : undefined;
        if (Array.isArray(condition.notIn)) {
            return value !== null
                && value !== undefined
                && !condition.notIn.includes(value);
        }
        if (Array.isArray(condition.in)) {
            return value !== null
                && value !== undefined
                && condition.in.includes(value);
        }
        if (condition.eq !== undefined) return value === condition.eq;
        if (condition.gt !== undefined) {
            return typeof value === 'number' && value > condition.gt;
        }
        if (condition.gte !== undefined) {
            return typeof value === 'number' && value >= condition.gte;
        }
        if (condition.nonEmpty) {
            if (value === null || value === undefined) return false;
            if (typeof value === 'string') return value.trim().length > 0;
            if (Array.isArray(value)) return value.length > 0;
        }
        return true;
    }

    public visibleSections(): any[] {
        return (this.schema()?.sections || []).filter(
            (section: any) => this.sectionVisible(section),
        );
    }

    public visibleQuestions(section: any): any[] {
        return (section?.questions || []).filter(
            (question: any) => this.questionVisible(question),
        );
    }

    public isSectionExpanded(index: number): boolean {
        return !!this.expandedSections[index];
    }

    public async toggleSection(index: number) {
        this.expandedSections[index] = !this.expandedSections[index];
        await this.service.render();
    }

    public async openSection(index: number) {
        this.expandedSections[index] = true;
        await this.service.render();
        setTimeout(() => {
            document.getElementById('result-section-' + index)
                ?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });
        });
    }

    public selectedResult(): any {
        return this.selectedContext?.result || {};
    }

    public selectedForm(): any {
        return this.forms.find(
            (form: any) => form.code === this.selectedFormCode,
        ) || {};
    }

    public parseFilename(
        contentDisposition: string | null,
        fallback: string,
    ): string {
        if (!contentDisposition) return fallback;
        const utfMatch = contentDisposition.match(
            /filename\*=UTF-8''([^;]+)/i,
        );
        if (utfMatch && utfMatch[1]) {
            try {
                return decodeURIComponent(utfMatch[1]);
            } catch (e) {
                return utfMatch[1];
            }
        }
        const asciiMatch = contentDisposition.match(
            /filename="?([^";]+)"?/i,
        );
        return asciiMatch?.[1] || fallback;
    }

    public async download(form: any, format: 'xlsx' | 'pdf') {
        if (!this.canUse(form) || this.downloadKey) return;
        this.downloadKey = `${form.code}:${format}`;
        await this.service.render();

        try {
            let path = (
                '/api/admin/subjects/'
                + encodeURIComponent(this.id)
                + '/forms/'
                + encodeURIComponent(form.code)
                + '/xlsx'
            );
            if (format === 'pdf') path += '?format=pdf';
            const response = await fetch(path, {
                method: 'GET',
                credentials: 'same-origin',
            });
            const contentType = response.headers.get('Content-Type') || '';
            if (!response.ok || contentType.includes('application/json')) {
                let message = `${format.toUpperCase()} 다운로드에 실패했습니다.`;
                try {
                    const body = await response.json();
                    message = body?.data?.message || body?.message || message;
                } catch (e) {}
                await this.service.modal.error(message);
                return;
            }

            const blob = await response.blob();
            const fallback = (
                `${this.subject.code || this.id}-${form.code}.${format}`
            );
            const filename = this.parseFilename(
                response.headers.get('Content-Disposition'),
                fallback,
            );
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            link.remove();
            URL.revokeObjectURL(url);
        } catch (e: any) {
            await this.service.modal.error(
                '네트워크 오류: '
                + (e && e.message ? e.message : e),
            );
        } finally {
            this.downloadKey = '';
            await this.service.render();
        }
    }

    public isDownloading(form: any, format: string): boolean {
        return this.downloadKey === `${form?.code}:${format}`;
    }

    public downloadMessage(): string {
        if (!this.downloadKey) return '파일 생성 중';
        const [formCode, format] = this.downloadKey.split(':');
        const form = this.forms.find(
            (item: any) => item.code === formCode,
        );
        return (
            `${this.formShortTitle(form)} `
            + `${String(format || '').toUpperCase()} 생성 중`
        );
    }

    public editPath(form: any): string {
        return (
            '/admin/subjects/'
            + this.id
            + '/forms/'
            + form.code
        );
    }
}

export default PageAdminResultsItemComponent;